export function getEnvImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getEnvProductImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_PRODUCT_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getEnvProductAssetImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_PRODUCT_ASSET_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getEnvReportDownloadPath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_REPORT_DOWNLOAD_URL_PRD;
  }
  return envUrl;
}

export function getEnvStaticImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_STATIC_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getOwnerImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_OWNER_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getEnvAssetImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_ASSET_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getEnvNetworkImagePath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_NETWORK_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getSignalRPath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_DEMO;
      break;
    case url.includes("prod."):
      envUrl = process.env.VUE_APP_SIGNALR_URL_PRD;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_SIGNALR_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_SIGNALR_URL;
  }
  return envUrl;
}

export function getEnvFaviconPath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_SANDBOX;
      break;
    case url.includes("poc."):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_POC;
      break;
    case url.includes("tst."):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_TST;
      break;
    case url.includes("acc."):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_ACC;
      break;
    case url.includes("demo."):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_DEMO;
      break;
    case url.includes("localhost"):
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_TST;
      break;
    default:
      envUrl = process.env.VUE_APP_FAVICON_IMAGE_URL_PRD;
  }
  return envUrl;
}

export function getDocumentationPath() {
  let envUrl;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox.") ||
         url.includes("poc.") ||
         url.includes("tst.") ||
         url.includes("acc.") ||
         url.includes("demo.") ||
         url.includes("prod.") ||
         url.includes("localhost"):
      envUrl = process.env.VUE_APP_DOCUMENTATION_URL_DEFAULT;
      break;
    default:
      envUrl = process.env.VUE_APP_DOCUMENTATION_URL_LIVE;
  }
  return envUrl;
}

export function checkPath() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = "sandbox";
      break;
    case url.includes("poc."):
      path = "poc";
      break;
    case url.includes("tst."):
      path = "tst";
      break;
    case url.includes("acc."):
      path = "acc";
      break;
    case url.includes("localhost"):
      path = "localhost";
      break;
    default:
      path = "prod";
  }
  return path;
}

export function getVueAppAuthority() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = process.env.VUE_APP_AUTHORITY_SANDBOX;
      break;
    case url.includes("poc."):
      path = process.env.VUE_APP_AUTHORITY_TST;
      break;
    case url.includes("tst."):
      path = process.env.VUE_APP_AUTHORITY_TST;
      break;
    case url.includes("acc."):
      path = process.env.VUE_APP_AUTHORITY_ACC;
      break;
    case url.includes("localhost"):
      path = process.env.VUE_APP_AUTHORITY_TST;
      break;
    default:
      path = process.env.VUE_APP_AUTHORITY;
  }
  return path;
}

export function getVueAppClientId() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = process.env.VUE_APP_CLIENT_ID_SANDBOX;
      break;
    case url.includes("poc."):
      path = process.env.VUE_APP_CLIENT_ID_TST;
      break;
    case url.includes("tst."):
      path = process.env.VUE_APP_CLIENT_ID_TST;
      break;
    case url.includes("acc."):
      path = process.env.VUE_APP_CLIENT_ID_ACC;
      break;
    case url.includes("localhost"):
      path = process.env.VUE_APP_CLIENT_ID_TST;
      break;
    default:
      path = process.env.VUE_APP_CLIENT_ID;
  }
  return path;
}

export function getAuth0Domain() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = process.env.VUE_APP_AUTH0_DOMAIN_SANDBOX;
      break;
    case url.includes("poc."):
      path = process.env.VUE_APP_AUTH0_DOMAIN_POC;
      break;
    case url.includes("tst."):
      path = process.env.VUE_APP_AUTH0_DOMAIN_TST;
      break;
    case url.includes("acc."):
      path = process.env.VUE_APP_AUTH0_DOMAIN_ACC;
      break;
    case url.includes("localhost"):
      path = process.env.VUE_APP_AUTH0_DOMAIN_TST;
      break;
    default:
      path = process.env.VUE_APP_AUTH0_DOMAIN;
  }
  return path;
}

export function getAuth0ClientID() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = process.env.VUE_APP_AUTH0_CLIENT_ID_SANDBOX;
      break;
    case url.includes("poc."):
      path = process.env.VUE_APP_AUTH0_CLIENT_ID_POC;
      break;
    case url.includes("tst."):
      path = process.env.VUE_APP_AUTH0_CLIENT_ID_TST;
      break;
    case url.includes("acc."):
      path = process.env.VUE_APP_AUTH0_CLIENT_ID_ACC;
      break;
    case url.includes("localhost"):
      path = process.env.VUE_APP_AUTH0_CLIENT_ID_TST;
      break;
    default:
      path = process.env.VUE_APP_AUTH0_CLIENT_ID;
  }
  return path;
}

export function getAuth0Audience() {
  let path;
  let url = window.location.href;
  switch(true) {
    case url.includes("sandbox."):
      path = process.env.VUE_APP_AUTH0_AUDIENCE_SANDBOX;
      break;
    case url.includes("poc."):
      path = process.env.VUE_APP_AUTH0_AUDIENCE_POC;
      break;
    case url.includes("tst."):
      path = process.env.VUE_APP_AUTH0_AUDIENCE_TST;
      break;
    case url.includes("acc."):
      path = process.env.VUE_APP_AUTH0_AUDIENCE_ACC;
      break;
    case url.includes("localhost"):
      path = process.env.VUE_APP_AUTH0_AUDIENCE_TST;
      break;
    default:
      path = process.env.VUE_APP_AUTH0_AUDIENCE;
  }
  return path;
}
